// --- Dependencies -------------------------------------------------------------------------------
import { useState } from "react";
// --- Our Modules --------------------------------------------------------------------------------
import Icon from "@/UI/atoms/Icon";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = {
    value: string;
    onChange: (value: string) => void;
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    error?: string | null;
    onEnter?: () => void;
};

/**
 * One bordered row that owns its focus ring, with the reveal toggle inside it rather than floating
 * over the field. Passwords here are issued by someone else and retyped often, so revealing matters.
 */
export default function PasswordInput({ value, onChange, label, placeholder, disabled, error, onEnter }: Props) {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div className="password-input">
            {label && <span className="password-input__label">{label}</span>}

            <div className={`password-input__box${error ? " password-input__box--error" : ""}`}>
                <input
                    className="password-input__field"
                    type={isVisible ? "text" : "password"}
                    value={value}
                    onChange={(event) => onChange(event.target.value)}
                    onKeyDown={(event) => event.key === "Enter" && onEnter?.()}
                    placeholder={placeholder}
                    disabled={disabled}
                    dir="ltr"
                />
                <button
                    type="button"
                    className="password-input__toggle"
                    onClick={() => setIsVisible((previous) => !previous)}
                    tabIndex={-1}
                    disabled={disabled}
                >
                    <Icon name={isVisible ? "eye-off" : "eye"} size={20} />
                </button>
            </div>

            {error && <span className="password-input__error">{error}</span>}
        </div>
    );
}
